import { Directive, ElementRef, forwardRef, HostListener, Input, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[appDecimalFormatting]',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DecimalFormattingDirective),
            multi: true
        }],
    standalone: true
})
export class DecimalFormattingDirective {
  private el = inject(ElementRef);


  @Input() initValue: number;

  private onTouched: () => void;
  private onChange: () => void;

  @HostListener('input', ['$event.target.value'])
  onInput(value: number): void {
    const formattedValue = this.formatDecimal(value);
    this.el.nativeElement.value = formattedValue;
    // this.onChange(value);
  }

  @HostListener('ready', ['$event.target.value'])
  onLoad(value: number): void {
    console.log("load...")
    const formattedValue = this.formatDecimal(value);
    this.el.nativeElement.value = formattedValue;
    // this.onChange(value);
  }


  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.el.nativeElement.value = this.formatDecimal(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  formatDecimal(val: number): string {
    const roundedNumber  = Math.round(val * 10) / 10
    return roundedNumber.toFixed(1);
  }

}
